module.exports = __webpack_public_path__ + "img/picto-nbre-surface.5823eff9.svg";